"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHighlight = void 0;
var _Highlight = require("./Highlight");
// TODO: in v9, move styled() from Highlight.jsx to here
var StyledHighlight = _Highlight.Highlight;
exports.StyledHighlight = StyledHighlight;